import { render, staticRenderFns } from "./EditorQuill.vue?vue&type=template&id=2bcda505&"
import script from "./EditorQuill.vue?vue&type=script&lang=js&"
export * from "./EditorQuill.vue?vue&type=script&lang=js&"
import style0 from "./EditorQuill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports